import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {PrimeNG} from 'primeng/config';
import {getAppPrimeTranslation} from './app-prime-locale';

@Injectable({providedIn: 'root'})
export class AppPrimeLocaleService {
	constructor(
		private readonly primeng: PrimeNG,
		translate: TranslateService,
	) {
		this.apply(translate.currentLang || translate.defaultLang || 'FR');
		translate.onLangChange.subscribe(({lang}) => this.apply(lang));
	}

	apply(lang: string): void {
		this.primeng.setTranslation(getAppPrimeTranslation(lang));
	}
}
